import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SharingBannerEl } from "common/widgets/sharing/banner";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/panel";
import { RowLabelType } from "common/query-builder/query-entry-section/types";
import { ButtonTheme, ButtonType } from "common/components/button/constants";
import { Placement } from "common/components/tooltip/types";
export function template() {
  const { error, open, stagedCustomEvent } = this.state;
  const canSaveCustomEvent = this.helpers.isStagedCustomEventValid();
  const nameHasError = error.invalidName || error.duplicateName || error.invalidSeparator;
  let nameErrorMessage = ``;
  if (nameHasError) {
    if (error.invalidName) {
      nameErrorMessage = `Please name your custom event.`;
    } else if (error.duplicateName) {
      nameErrorMessage = `A custom event with that name already exists.`;
    } else if (error.invalidSeparator) {
      nameErrorMessage = `Please refrain from using " / " (forward slash with spaces) in your custom event's name.`;
    }
  }
  return /* @__PURE__ */ jsx(ModalEl, {
    sel: ".custom-event-modal",
    attrs: {
      open,
      closeable: true,
      "grow-to-content": true,
      "close-confirm-text": this.helpers.hasUnsavedChanges() ? `Changes  made will not be applied.` : ``
    },
    on: {
      change: (ev) => this.helpers.handleModalChange(ev)
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-event-modal-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-header-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-title"
  }, this.helpers.isNewCustomEvent() ? `Create Custom Event` : `Edit Custom Event - ${stagedCustomEvent.name}`))), /* @__PURE__ */ jsx(SharingBannerEl, {
    sel: ".sharing-banner",
    attrs: this.helpers.getSharingBannerAttrs()
  }), /* @__PURE__ */ jsx("div", {
    sel: ".custom-event-name-subheader"
  }, /* @__PURE__ */ jsx(InputEl, {
    attrs: {
      maxlength: this.helpers.MAX_NAME_LENGTH,
      label: `Name`,
      necessary: `required`,
      "validation-status": nameHasError ? `invalid` : ``,
      "error-message": nameErrorMessage
    },
    on: {
      input: this.helpers.updateCustomEventName,
      focus: this.helpers.clearNameErrors
    },
    hook: {
      insert: this.helpers.nameInputInserted
    },
    props: {
      value: stagedCustomEvent.name
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".custom-event-match-text"
  }, "Match my custom event when any of the following events happen"), /* @__PURE__ */ jsx("div", {
    sel: ".custom-event-builder"
  }, /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    showAllEvents: this.canUseAllEvents(),
    dataGroupsEnabled: this.attr(`all-data-groups`),
    disableFirstTimeEventFilters: true,
    entries: this.getEntries(),
    enableEnhancedListFilters: true,
    hideEditControls: true,
    includeCustomProperties: "persisted-non-behavioral-only",
    showBorrowedProperties: true,
    projectHasPeople: this.attr(`project-has-people`),
    projectId: this.attr(`project-id`),
    rowDraggable: true,
    rowLabelType: RowLabelType.None,
    workspaceId: this.attr(`workspace-id`),
    projectAsOfDate: this.attr(`project-as-of-date`),
    trackName: this.attr(`track-name`),
    onUpdate: this.helpers.updateQueryEvents,
    onTrack: this.helpers.captureTracking
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".footer"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".delete-custom-event-button"
  }, stagedCustomEvent.id ? /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".delete-custom-event-button",
    key: "delete-custom-event-button",
    attrs: {
      elref: `deleteCustomEventButton`,
      type: ButtonType.Destructive,
      icon: `trashcan`,
      tooltip: {
        placement: Placement.Right,
        text: `Delete custom event`,
        "always-show": true
      }
    },
    on: { click: () => this.handleDeleteClick() }
  }) : this.helpers.showShareManagement() ? /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".save-and-share-button",
    attrs: {
      theme: ButtonTheme.Secondary,
      disabled: !canSaveCustomEvent
    },
    on: { click: () => this.helpers.clickSave({ andShare: true }) }
  }, "Save and Share") : null), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".save-custom-event-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: !canSaveCustomEvent
    },
    on: { click: () => this.helpers.clickSave() }
  }, "Save"))));
}
